module.exports = __webpack_public_path__ + "img/imgVirtualTryOn02.cb220d4c.png";